import { Key } from 'ts-key-enum';
import EventManager from "./lib/EventManager";
import * as Events from "./Events";
import state from "./State";

document.addEventListener('keydown', event => {

  if (event.key === Key.ArrowRight || event.key === 'd') {
    EventManager.emit('move', 'right')
  }

  if (event.key === Key.ArrowLeft || event.key === 'a') {
    EventManager.emit('move', 'left')
  }

  if (event.key === Key.ArrowDown || event.key === 's') {
    EventManager.emit('move', 'down')
  }

  if (event.key === Key.ArrowUp || event.key === 'w') {
    EventManager.emit('move', 'up')
  }

  if (event.key === 'u') {
    EventManager.emit('undo')
  }

  if (event.key === 'r') {
    // EventManager.emit(Events.selectAlien, 'red')
    state.init()
  }

  if (event.key === 'y') {
    EventManager.emit(Events.selectAlien, 'yellow')
  }

  if (event.key === 'g') {
    EventManager.emit(Events.selectAlien, 'green')
  }



  if (event.key === '1') {
    // EventManager.emit('select-tile', 0);
    EventManager.emit(Events.selectAlien, 'green')
  }

  if (event.key === '2') {
    // EventManager.emit('select-tile', 1);
    EventManager.emit(Events.selectAlien, 'yellow')

  }

  if (event.key === '3') {
    // EventManager.emit('select-tile', 2);
    EventManager.emit(Events.selectAlien, 'red')
  }

})
